import { createEnv } from "@t3-oss/env-nextjs"
import { z } from "zod"

// server + client = runtimeEnv
export const env = createEnv({
	/**
	 * 指定哪些环境变量是必需的
	 */
	server: {
		NODE_ENV: z.enum(["development", "test", "production"]).optional(),
		NEWS_CENTER_INNER: z.string(),
		USER_CENTER_INNER: z.string(),
		SPOT_CENTER_INNER: z.string(),
	},
	/**
	 * 指定哪些环境变量在客户端可用
	 */
	client: {
		NEXT_PUBLIC_ENV: z.enum(["development", "test", "production"]),
		NEXT_PUBLIC_NAME: z.string(),
		NEXT_PUBLIC_API_HOST_EN: z.url(),

		NEXT_PUBLIC_AUTH_TOKEN_KEY: z.string(),

		NEXT_PUBLIC_DEPLOY_CDN: z.string(),
		NEXT_PUBLIC_DEPLOY_HOST: z.url(),
		NEXT_PUBLIC_DEPLOY_SUFFIX: z.string(),
		NEXT_PUBLIC_DEPLOY_VERSION: z.string(),
		NEXT_PUBLIC_SENTRY_DSN: z.string().url().optional(),
		// NEXT_PUBLIC_SENTRY_AUTH_TOKEN: z.string(),
		NEXT_PUBLIC_SENTRY_ENABLED: z
			.string()
			.transform((val) => val === "true")
			.optional()
			.default(false),
	},

	/**
	 * 运行时环境变量验证
	 */
	runtimeEnv: {
		// 运行时环境
		NODE_ENV: process.env.NODE_ENV,
		NEXT_PUBLIC_ENV: process.env.NEXT_PUBLIC_ENV,
		NEXT_PUBLIC_NAME: process.env.NEXT_PUBLIC_NAME,
		NEXT_PUBLIC_AUTH_TOKEN_KEY: process.env.NEXT_PUBLIC_AUTH_TOKEN_KEY,

		// api 配置
		NEWS_CENTER_INNER: process.env.NEWS_CENTER_INNER,
		USER_CENTER_INNER: process.env.USER_CENTER_INNER,
		SPOT_CENTER_INNER: process.env.SPOT_CENTER_INNER,
		NEXT_PUBLIC_API_HOST_EN: process.env.NEXT_PUBLIC_API_HOST_EN,

		// cdn 配置
		NEXT_PUBLIC_DEPLOY_CDN: process.env.NEXT_PUBLIC_DEPLOY_CDN,
		NEXT_PUBLIC_DEPLOY_HOST: process.env.NEXT_PUBLIC_DEPLOY_HOST,
		NEXT_PUBLIC_DEPLOY_SUFFIX: process.env.NEXT_PUBLIC_DEPLOY_SUFFIX,
		NEXT_PUBLIC_DEPLOY_VERSION: process.env.NEXT_PUBLIC_DEPLOY_VERSION,

		// sentry 配置
		NEXT_PUBLIC_SENTRY_DSN: process.env.NEXT_PUBLIC_SENTRY_DSN,
		// NEXT_PUBLIC_SENTRY_AUTH_TOKEN: process.env.NEXT_PUBLIC_SENTRY_AUTH_TOKEN,
		NEXT_PUBLIC_SENTRY_ENABLED: process.env.NEXT_PUBLIC_SENTRY_ENABLED,
	},
})
